export default "__VITE_ASSET__9Tvcej7Vn4Z5qzWbOEh35w__"